function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.56 12.85a.8.8 0 01-1.52-.5c-.01.04 0 0 0 0a2.66 2.66 0 01.1-.27 8.76 8.76 0 011.57-2.42A8.23 8.23 0 0111.99 7a8.23 8.23 0 017.97 5.44l.03.16s.13.53-.55.75a.8.8 0 01-1-.5l-.02-.03a3.38 3.38 0 00-.27-.6A6.63 6.63 0 0012 8.6a6.63 6.63 0 00-6.43 4.22l-.01.03z",
  fill: "#1C1C1C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.8 13.4a3.2 3.2 0 116.4 0 3.2 3.2 0 01-6.4 0z",
  fill: "#1C1C1C"
})));